import axios from 'axios';
import { getMethod } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_PRACTICE = 'GET_PRACTICE';
export const GET_PRACTICE_SUCCESS = 'GET_PRACTICE_SUCCESS';
export const GET_PRACTICE_FAILURE = 'GET_PRACTICE_FAILURE';

// Action Creators
export const getPracticeRequest = () => ({
  type: GET_PRACTICE,
});

export const getPracticeSuccess = (users) => ({
  type: GET_PRACTICE_SUCCESS,
  payload: users,
});

export const getPracticeFailure = (error) => ({
  type: GET_PRACTICE_FAILURE,
  payload: error,
});

// Thunk Function
export const getPracticeList = (external) => {
  return async (dispatch) => {
    dispatch(getPracticeRequest());
    try {
      const response = await getMethod(url?.getPractices);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getPracticeSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getPracticeFailure(error?.message));
    }
  };
};
